import React from "react";
import { useModal } from "../../../../hooks/ModalContext";
import { SelectTipo } from '../../../OperadorCaixa/components/select-tipo'
import { CustomFlowbiteTheme, Modal } from "flowbite-react";

interface SelectTipoProps {
  tipoDiscagem: string
  setTipoDiscagem: React.Dispatch<React.SetStateAction<string>>
  handleButton(): void
  isCaixa?: boolean
}


export const TipoDiscagemModal = ({ tipoDiscagem, setTipoDiscagem, handleButton, isCaixa }: SelectTipoProps) => {
  const { onClose, openTipoDiscagemModal } = useModal();
  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: 'fixed top-0 right-0 left-0 z-40 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full'
    },

  }

  function handleClose() {
    handleButton()
    onClose()
  }

  return (
    <>
      <Modal
        show={openTipoDiscagemModal.isOpen}
        // show={true}
        popup={true}
        size={"md"}
        // onClick={() => onClose()}
        theme={themeModal}
      >
        <Modal.Body>
          <div className="w-[100%] p-2 -mb-6">
            <SelectTipo tipoDiscagem={tipoDiscagem} setTipoDiscagem={setTipoDiscagem} handleButton={handleClose} width="100%" height="100%" nameButton="Fechar" isCaixa={isCaixa} />
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};
